import { combineReducers } from 'redux';
import { experimentTakeoverReducer as experimentTakeoverInfoReducer } from './takeoverReducer';
import { campaignInfoReducer } from './campaignInfoReducer';
import { experimentReducer } from './experimentReducer';

export const experimentTakeoverReducer = combineReducers({
  info: experimentTakeoverInfoReducer,
  campaignInfo: campaignInfoReducer,
  experiment: experimentReducer,
});
